import clientDashboardGuard from '@/modules/admin/dashboard/guards/clientDashboardGuard';

export default {
  path: '/dashboard/:clientSlug',
  name: 'dashboard-client',
  component: () => import(/* webpackChunkName: "dashboard-client" */ '@/layouts/PublicBlankLayout.vue'),
  beforeEnter: [clientDashboardGuard],
  children: [
    {
      path: '',
      name: 'dashboard-client-view',
      component: () => import(/* webpackChunkName: "dashboard-client" */ '@/modules/admin/dashboard/views/ClientDashboard.vue'),
    },
  ],
};
